/* eslint-disable prefer-destructuring */
import gqlService from '@modules/forgotpassword/services/graphql';
import { useRouter } from 'next/router';
import Layout from '@layout';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { regexEmail } from '@helper_regex';

const URL_SET_NEW_PASSWORD = '/forgotpassword/createnewpassword';

const ContentWrapper = (props) => {
    const { Content, storeLogo, t } = props;
    const router = useRouter();
    const [requestResetPassword] = gqlService.requestResetPassword();

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object().shape({
            email: Yup.string().required(t('forgotpassword:This_is_a_Required_field'))
                .matches(regexEmail, t('forgotpassword:Invalid_email_format')),
        }),
        onSubmit: async (values) => {
            const { ...restValues } = values;
            const variables = {
                email: restValues.email,
                callback_url: URL_SET_NEW_PASSWORD,
            };
            window.backdropLoader(true);

            requestResetPassword({
                variables,
            })
                .then(() => {
                    window.backdropLoader(false);
                    window.toastMessage({
                        open: true,
                        variant: 'success',
                        // eslint-disable-next-line max-len
                        text: t('forgotpassword:If_there_is_an_account_associated_with_valuesemail_you_will_receive_an_email_with_a_link_to_reset_your_password',
                            { values }),
                    });
                    setTimeout(() => router.push('/login'), 2000);
                })
                .catch((e) => {
                    window.backdropLoader(false);
                    window.toastMessage({
                        open: true,
                        variant: 'error',
                        text: e.message,
                    });
                });
        },
    });

    const contentProps = {
        formik,
        storeLogo,
        t,
    };

    return (
        <Content {...contentProps} />
    );
};

const Core = (props) => {
    const { t } = props;
    const pageConfig = {
        header: false,
        sidebar: false,
        title: t('forgotpassword:Set_a_New_Password'),
    };

    const contentProps = {
        ...props,
    };

    return (
        <Layout pageConfig={pageConfig}>
            <ContentWrapper
                {...contentProps}
            />
        </Layout>
    );
};

export default Core;
